import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import { render } from "react-dom";
import axios from "axios";
import { getToken } from "../../Utils/Common";
import { ResponseMessage } from "../../components/messages/response-message";

function WriteReview() {

  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [avgRating, setAvgRating] = useState(null);
  const [isPreview, setIsPreview] = useState("");
  const [isEdit, setIsEdit] = useState("");

  const token = getToken();
  const { book_code } = useParams();

  const [state, setState] = React.useState({
    overall_star: null,
    performance_star: null,
    story_star: null,
    title: "",
    review: "",
  });

  console.log(error);

  useEffect(() => {
    console.log("loading");
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + `v1/guest/book-detail/${book_code}`,
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        // console.log(response.data.data);
        setAvgRating(response.data.data.average_rating);
        setData(response.data.data);

        // setLoader(false);
      })
      .catch((err) => {
        // setLoader(false);
        console.log(err.response.data.message);
        if (err.response.status === 422) {
          // console.log(error.response.data);
          setStatus(422);
          setMessage(err.response.data.message);
          // setErrorMessage(error.response.data.message);
        } else if (err.response.status === 401) {
          setStatus(401);
          setMessage(err.response.data.message);

          // setErrorMessage(error.response.data.message);
        } else if (err.response.status === 500) {
          setStatus(500);
          setMessage(err.response.data.message);
          // setErrorMessage(error.response.data.message);
        } else {
          setStatus(500);
          setMessage(err.response.data.message);
          // setErrorMessage("Something went wrong. Please try again later.");
        }
      });
  }, []);

  // console.log(data);

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const back = () => {
    // console.log("d");
    navigate(-1);
  };

  const OverallRating = {
    size: 25,
    count: 5,
    isHalf: false,
    value: 1,
    color: "grey",
    activeColor: "#ff6600",
    onChange: (newValue) => {
      // console.log(`Example 3: new value is ${newValue}`);
      setState({
        ...state,
        ["overall_star"]: newValue,
      });
    },
  };

  console.log(typeof state.OverallRating);

  const performanceRating = {
    size: 25,
    count: 5,
    isHalf: false,
    value: 1,
    color: "grey",
    activeColor: "#ff6600",
    onChange: (newValue) => {
      // console.log(`Example 3: new value is ${newValue}`);
      setState({
        ...state,
        ["performance_star"]: newValue,
      });
    },
  };

  const averageRating = {
    size: 25,
    count: 5,
    isHalf: true,
    value: avgRating,
    color: "grey",
    activeColor: "#ff6600",
    edit: false,
  };

  const overRating = {
    size: 25,
    count: 5,
    isHalf: true,
    value: state.overall_star,
    color: "grey",
    activeColor: "#ff6600",
    edit: false,
  };

  const perRating = {
    size: 25,
    count: 5,
    isHalf: true,
    value: state.performance_star,
    color: "grey",
    activeColor: "#ff6600",
    edit: false,
  };

  const stRating = {
    size: 25,
    count: 5,
    isHalf: true,
    value: state.story_star,
    color: "grey",
    activeColor: "#ff6600",
    edit: false,
  };


  const storyRating = {
    size: 25,
    count: 5,
    isHalf: false,
    value: 1,
    color: "grey",
    activeColor: "#ff6600",
    onChange: (newValue) => {
      // console.log(`Example 3: new value is ${newValue}`);
      setState({
        ...state,
        ["story_star"]: newValue,
      });
    },
  };

  // console.log("per", state.performance_star);
  const handlePreview = () => {
    console.log("click me");
    setIsPreview("preview");
  };

  const handleEdit = () => {
    setIsEdit("")
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    setError([]);
    setsucessMessage("");

    var formData = new FormData();
    formData.append("title", state.title);
    formData.append("overall_star", state.overall_star);
    formData.append("performance_star", state.performance_star);
    formData.append("story_star", state.story_star);
    formData.append("review", state.review);
    formData.append("book_code", book_code);

    for (var key of formData.entries()) {
      formData[key[0]] = key[1];
      console.log(formData);
    }

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/review`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        console.log(response.data);
        if (response.status === 200) {
          setsucessMessage(response.data.message);
          setStatus(200);
          setMessage(response.data.message)
          // console.log(response);
        }
      })
      .catch((error) => {
        if (error.response.status === 422) {
          console.log(error.response.data.message);
          // setError(error.response.data.message);
          // setErrorMessage(error.response.data.message);
          setStatus(422);
          setError(error.response.data.errors);
          setMessage(error.response.data.message);
          setIsEdit("edit");

        } else if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
          setMessage(error.response.data.message);
          setError(error.response.data.errors);
        } else {
          console.log(error.response);
          setError("Something went wrong. Please try again later.");
        }
        console.log(error.response);
      });
  };

  // console.log(avgRating);
  return (
    <div className="card mb-5 mb-xl-8" style={{ marginTop: "100px" }}>
      <div className="container-xxl" id="kt_content_container">
        <div
          className="card-body pt-9 pb-0"
          style={{ marginLeft: "220px", marginRight: "100px" }}
        >
          <div className="row">
            <div className="col-12">
              {/* <p style={{ color: "green", fontSize: "20px" }}>
                {sucessMessage}
              </p> */}
              <ResponseMessage status={status} message={message} />
              <div className="row">
                <div className="col-12">
                  <h1> Write A Review </h1>
                </div>
              </div>

              <div className="row">
                <div className="col-2">
                  <img
                    alt="Pic"
                    src={data.image_path}
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>

                {Object.entries(data).length > 0 ? (
                  <div className="col-10">
                    <div className="row">
                      <div className="col-4">
                        <div className="row">
                          <div className="col-12">
                            {" "}
                            <b>By: </b>
                            {data.author}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <b>Narrated By:</b> {data.narrated_by}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <b>Length:</b> {data.hours} Hrs and {data.minutes}
                            Mins
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <b>AudioBook</b>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div
                                className="col-4"
                                style={{ padding: "10px" }}
                              >
                                <b>Rating:</b>
                              </div>
                              <div className="col-8">
                                <ReactStars {...averageRating} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2"></div>
                      <div className="col-4"></div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div style={{ marginTop: "25px" }}>
                  {" "}
                  <hr />{" "}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mt-19">

              {isPreview === "preview" ? (
                <>
                  <div className="d-flex justify-content-between">
                    <div className="col-2">
                      <div className="col-12"> Overall </div>
                      <div className="col-12"> Performance </div>
                      <div className="col-12"> Story </div>
                      <div className="col-12"> Date </div>
                    </div>
                    <div className="col-2">
                      <div className="col-12">
                        <ReactStars {...overRating} />
                      </div>
                      <div className="col-12">
                        <ReactStars  {...perRating} />
                      </div>
                      <div className="col-12">
                        <ReactStars {...stRating} />
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="col-12"> {state.title} </div>
                      <p style={{ color: "red" }}>
                        {error.title !== undefined && error.title[0]
                          ? error.title[0]
                          : ""}
                      </p>
                      <div className="col-12"> {state.review} </div>
                      <p style={{ color: "red" }}>
                        {error.review !== undefined && error.review[0]
                          ? error.review[0]
                          : ""}
                      </p>
                    </div>
                  </div>

                  <div className="fs-1">
                    <span>Difficulty:</span>{" "}
                    <span
                      className={
                        data.difficulty === "Easy" ? "border-active-light" : ""
                      }
                    >
                      Easy
                    </span>
                    /{" "}
                    <span
                      className={
                        data.difficulty === "Medium"
                          ? "border-active-light"
                          : ""
                      }
                    >
                      Medium
                    </span>{" "}
                    /{" "}
                    <span
                      className={
                        data.difficulty === "Hard" ? "border-active-light" : ""
                      }
                    >
                      Hard
                    </span>
                  </div>
                  <div className="">
                    <form onSubmit={handleSubmit}>
                      <div className="row" style={{ marginTop: "30px" }}>
                        <div className="col-8"></div>

                        <div className="col-2">
                          {/* <button type="button" onClick={back} className="btn btn-danger"> */}
                          <Link to={`#`} className="btn btn-danger" onClick={back}>
                            Edit
                          </Link>
                          {/* </button> */}
                        </div>

                        <div className="col-2">
                          <button type="submit" className="btn btn-success">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              ) : (

                <div className="row">
                  <div className="col-2"></div>

                  <div className="col-10">
                    <form method="POST" onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="row">
                            <div className="col-4">
                              {" "}
                              <h3>1. Please rate this title: </h3>{" "}
                            </div>
                            <div className="col-7 fs-1">
                              {" "}
                              <span>Difficulty:</span>{" "}
                              <span
                                className={
                                  data.difficulty === "Easy"
                                    ? "border-active-light"
                                    : ""
                                }
                              >
                                Easy
                              </span>
                              /{" "}
                              <span
                                className={
                                  data.difficulty === "Medium"
                                    ? "border-active-light"
                                    : ""
                                }
                              >
                                Medium
                              </span>{" "}
                              /{" "}
                              <span
                                className={
                                  data.difficulty === "Hard"
                                    ? "border-active-light"
                                    : ""
                                }
                              >
                                Hard
                              </span>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="row">
                            <div className="col-4">
                              <div className="row">
                                <div
                                  className="col-4"
                                  style={{ padding: "10px" }}
                                >
                                  Overall
                                </div>
                                <div className="col-7">
                                  {" "}
                                  <ReactStars {...OverallRating} />
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="row">
                                <div
                                  className="col-6"
                                  style={{ padding: "10px" }}
                                >
                                  Performance
                                </div>
                                <div className="col-6">
                                  <ReactStars {...performanceRating} />
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="row">
                                <div
                                  className="col-4"
                                  style={{ padding: "10px" }}
                                >
                                  Story
                                </div>
                                <div className="col-7">
                                  <ReactStars {...storyRating} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "20px" }}>
                        <div className="col-12">
                          <h3>2. Enter a headline for your review </h3>
                          <input
                            className="form-control form-control-lg form-control-solid"
                            type="text"
                            name="title"
                            id="title"
                            placeholder="Enter Text here..."
                            onChange={handleChange}
                            autoComplete=""
                            required
                          />
                          <label style={{ textAlign: "right" }}>
                            {" "}
                            maximum 50 characters{" "}
                          </label>
                          <p style={{ color: "red" }}>
                            {error.title !== undefined && error.title[0]
                              ? error.title[0]
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: "20px" }}>
                        <div className="col-12">
                          <h3>3. Review this Title </h3>

                          <textarea
                            className="form-control form-control-lg form-control-solid"
                            type="text"
                            name="review"
                            id="review"
                            placeholder="Enter Text Here..."
                            onChange={handleChange}
                            required
                            rows="4"
                            cols="50"
                            autoComplete="true"
                          />
                          <label>minimum 15 words and 25 characters</label>
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: "20px" }}>
                        <div className="col-12">
                          <p>
                            {" "}
                            Please note: By submitting this review you confirm
                            you have read and agree to our{" "}
                            <Link to={`#`}>Review Guidelines</Link>
                          </p>
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: "30px" }}>
                        <div className="col-8"></div>

                        <div className="col-2">
                          <button
                            onClick={back}
                            type="submit"
                            className="btn btn-danger"
                          >
                            Cancel
                          </button>
                        </div>

                        <div className="col-2">
                          <button
                            type="button"
                            onClick={() => handlePreview()}
                            className="btn btn-success"
                          >
                            Preview
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div style={{ marginTop: "25px" }}></div>
                </div>
              )}

              {/* <div className="row">
                <div className="col-2"></div>

                <div className="col-10">
                  <form method="POST" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <h3>1. Please rate this title: </h3>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="row">
                          <div className="col-4">
                            <div className="row">
                              <div
                                className="col-4"
                                style={{ padding: "10px" }}
                              >
                                Overall
                              </div>
                              <div className="col-7">
                                {" "}
                                <ReactStars {...OverallRating} />
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="row">
                              <div
                                className="col-6"
                                style={{ padding: "10px" }}
                              >
                                Performance
                              </div>
                              <div className="col-6">
                                <ReactStars {...performanceRating} />
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="row">
                              <div
                                className="col-4"
                                style={{ padding: "10px" }}
                              >
                                Story
                              </div>
                              <div className="col-7">
                                <ReactStars {...storyRating} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ marginTop: "20px" }}>
                      <div className="col-12">
                        <h3>2. Enter a headline for your review </h3>
                        <input
                          className="form-control form-control-lg form-control-solid"
                          type="text"
                          name="title"
                          id="title"
                          placeholder="Enter Text here..."
                          onChange={handleChange}
                          autoComplete=""
                          required
                        />
                        <label style={{ textAlign: "right" }}>
                          {" "}
                          maximum 50 characters{" "}
                        </label>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "20px" }}>
                      <div className="col-12">
                        <h3>3. Review this Title </h3>

                        <textarea
                          className="form-control form-control-lg form-control-solid"
                          type="text"
                          name="review"
                          id="review"
                          placeholder="Enter Text Here..."
                          onChange={handleChange}
                          required
                          rows="4"
                          cols="50"
                          autoComplete="true"
                        />
                        <label>minimum 15 words and 25 characters</label>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "20px" }}>
                      <div className="col-12">
                        <p>
                          {" "}
                          Please note: By submitting this review you confirm you
                          have read and agree to our{" "}
                          <Link to={`#`}>Review Guidelines</Link>
                        </p>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "30px" }}>
                      <div className="col-8"></div>

                      <div className="col-2">
                        <button
                          onClick={back}
                          type="submit"
                          className="btn btn-danger"
                        >
                          Cancel
                        </button>
                      </div>

                      <div className="col-2">
                        <button
                          type="submit"
                          onClick={() => handlePreview()}
                          className="btn btn-success"
                        >
                          Preview
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div style={{ marginTop: "25px" }}></div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WriteReview;
